__webpack_require__.p = "/the-fast-way-task/";